import { SvgIcon } from "@mui/material";

const YahooIcon = () => {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Yahoo-Logo--Streamline-Logos"
        height="24"
        width="24"
      >
        <path
          fill="rgba(0, 0, 0, 0.54)"
          fill-rule="evenodd"
          d="M18.5 12H14l4.5 -10H23l-4.5 10Zm-1 3.5a2.5 2.5 0 1 1 -5 0 2.5 2.5 0 0 1 5 0ZM1 7h4.5L8 13l2.5 -6h4L8 22H4l2 -4L1 7Z"
          clip-rule="evenodd"
          stroke-width="1"
        ></path>
      </svg>
    </SvgIcon>
  );
};

export default YahooIcon;
